<script setup>
import { computed } from 'vue'

const serviceCount = computed(() => {
    return  window.prebook.services
})
</script>
<template>
    <div class="flex flex-col gap-3">
        <!-- loader item -->
        <div v-for="i in serviceCount" class="animate-pulse flex border pl-3 pr-4 py-3 rounded-lg border-solid border-[#EAECF0] w-full justify-between items-center">
            <div class="flex">
                <div class="w-[88px] h-[60px] rounded-md bg-[#EAECF0]"></div>
                <div class="flex flex-col gap-2.5 justify-center px-4">
                    <div class="w-[147px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                    <div class="w-[34px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                </div>
            </div>
            <div class="w-[34px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
        </div>
    </div>
</template>